import { Content } from 'rsuite';
import { ProductsSearchProvider } from '../../hooks/ProductsSearchContext';
import { ChannelSelector } from './ChannelSelector';
import { CompetitorSelector } from './CompetitorSelector';
import { FilterActions } from './FilterActions';
import { LocationSelector } from './LocationSelector';
import { ProductSelector } from './ProductSelector';
import styles from './styles.module.scss';

export const FiltersArea = () => {
  return (
    <ProductsSearchProvider>
      <Content className={styles.filtersAreaContent}>
        <div className={styles.innerDiv}>
          <div className={styles.filtersColumn}>
            <ProductSelector />
            <CompetitorSelector />
            <ChannelSelector />
            <LocationSelector />
          </div>

          <FilterActions />
        </div>
      </Content>
    </ProductsSearchProvider>
  );
};
